module.exports = __webpack_public_path__ + "img/0Q3A6963_L_WoodMatted_MockedUp.5aea388b.jpg";